export default __webpack_public_path__ + "static/media/gerenBg.fcfd2a53.png";